import { ReactElement } from 'react';
import { FieldArray, FieldArrayRenderProps, useFormikContext } from 'formik';
import Grid from '@mui/material/Grid';
import { Box, Fab, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import classNames from 'classnames';
import get from 'lodash/get';

// Components
import { FormikInputField, FormikNumberField } from '../ContinuousImprovement/PureFormElements';

// Styles
import styles from './TextboxRepeater.module.scss';

// Types
interface IProps {
  disabled?: boolean;
  formikKey: string;
  labelPrompt?: string;
  payloadValue?: string;
}
export const TextboxRepeater = (props: IProps): ReactElement => {
  const { disabled, formikKey, labelPrompt, payloadValue } = props;
  const { setFieldTouched, values } = useFormikContext();
  const label: string = labelPrompt && `${labelPrompt}:`;
  const formikAccess: string[] = get(values, formikKey);

  return (
    <FieldArray
      name={formikKey}
      render={(arrayHelpers: FieldArrayRenderProps): ReactElement => {
        return (
          <Grid container>
            {formikAccess?.map((item: string, idx: number): ReactElement => {
              return (
                <Grid container spacing={3} component={Box} key={idx} sx={{ display: 'flex' }}>
                  <Grid size={{ xs: 7, sm: 8 }}>
                    <FormikInputField
                      label={`${label ?? ''} ${idx + 1}`}
                      name={item}
                      formikKey={`${formikKey}.${idx}.${payloadValue}`}
                    />
                  </Grid>
                  <Grid size={{ xs: 4, sm: 3 }}>
                    <FormikNumberField
                      formikKey={`${formikKey}.${idx}.sortOrder`}
                      label="Sort Order"
                      min={1}
                      step={1}
                    />
                  </Grid>
                  <Grid component={Box} sx={{ alignSelf: 'center', mt: 3, ml: 0 }}>
                    <IconButton aria-label="remove" onClick={(): void => arrayHelpers.remove(idx)} size="small">
                      <ClearIcon fontSize="inherit" />
                    </IconButton>
                  </Grid>
                </Grid>
              );
            })}
            <Box sx={{ display: 'flex', pt: 2, pb: 2 }}>
              <Box sx={{ mr: 2 }}>
                <Fab
                  aria-label="add another instance"
                  className={classNames(
                    {
                      [styles.disabled]: disabled,
                    },
                    styles['add-btn'],
                  )}
                  disabled={disabled}
                  onClick={(): void => {
                    arrayHelpers.push({ sortOrder: formikAccess.length + 1 });
                    setFieldTouched(formikKey, true);
                  }}
                  size="small"
                >
                  <AddIcon color="inherit" />
                </Fab>
              </Box>
              <Box sx={{ pt: 0.5 }}>Add Another Instance</Box>
            </Box>
          </Grid>
        );
      }}
    />
  );
};
